module.exports = __webpack_public_path__ + "static/media/calendar-blue.34fc79f5.svg";